// src/App.js
import React, { useState, useEffect } from 'react';
import { GlobalProvider } from './contexts/GlobalContext';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Header from './components/Header';
import Sidebar from './components/Sidebar';
import AppRoutes from './AppRoutes';
import Footer from './components/Footer';

function App() {
  const initialFontSize = parseInt(localStorage.getItem('fontSize')) || 14;
  const [fontSize, setFontSize] = useState(initialFontSize);

  useEffect(() => {
    document.documentElement.style.setProperty('--body-font-size', `${fontSize}pt`);
    localStorage.setItem('fontSize', fontSize);
  }, [fontSize]);

  // Update the CSS variable when fontSize changes
  useEffect(() => {
    document.documentElement.style.setProperty('--body-font-size', `${fontSize}pt`);
  }, [fontSize]);

  const decreaseFontSize = () => {
    setFontSize((prevSize) => Math.max(prevSize - 1, 10));
  };

  const resetFontSize = () => {
    setFontSize(14);
  };

  const increaseFontSize = () => {
    setFontSize((prevSize) => Math.min(prevSize + 1, 22));
  };

  return (
    <GlobalProvider>
      <BrowserRouter>
        <div className="App">
          <Header
            onFontSizeDecrease={decreaseFontSize}
            onFontSizeReset={resetFontSize}
            onFontSizeIncrease={increaseFontSize}
          />
          <div className="main-content">
            <Sidebar />
            <div className="content">
              <AppRoutes />
            </div>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </GlobalProvider>
  );
}

export default App;
